import { useScroll } from 'ahooks'
import { kebabCase } from 'lodash-es'
import React from 'react'

import style from './index.module.scss'

import type { CSSProperties } from 'react'


import { useState, useCallback, useMemo } from 'react';
import { cls } from 'tagged-classnames-free';
export interface IAnchorProps {
  // 内部容器 className
  className?: string
  // 宽度
  width?: number
  // 最外层容器 className
  wrapperClassName?: string
  style?: CSSProperties
  // 其他自定义样式
  classNames?: {
    textColor?: string
    activeClass?: string
    scrollBarTrackClass?: string
  }

  items: {
    key: string
    title: string
    href?: string
  }[]
}

/**
 *
 * @param wrapperClassName  最外层容器 className
 * @param className  内部容器 className
 * @param classNames  其他自定义样式支持
 * @param style
 * @param items  数据项
 * @returns
 */
const ArticleAnchor: React.FC<IAnchorProps> = (props) => {
  const { items, className, classNames, wrapperClassName } = props
  const [active, setActive] = useState<string>('')
  const scroll = useScroll()

  const scrollToSection = useCallback((id: string) => {
    setActive(id)
    const element = document.getElementById(kebabCase(id))
    if (element) {
      element.scrollIntoView({ block: 'start', behavior: 'smooth' })
    }
  }, [])

  const isScroll = useMemo(() => {
    if (scroll && scroll?.top === 0) {
      setActive('')
      return false
    }
    return true
  }, [scroll])

  const activeStyle = 'text-f-primary after:bg-f-primary'
  return (
    <div className={`${style.articleAnchor} hidden lg:inline-block`}>
      <div
        className={cls`
          border-f-border sticky top-20 h-fit
          w-[224px] overflow-hidden 
          rounded-lg border py-3 
          ${wrapperClassName}
        `}
      >
        <ul
          className={cls`
            relative
            space-y-3
            pe-3 ps-6 text-sm
            after:absolute after:inset-y-1
            after:left-2.5 after:h-full
            after:w-[2px]
            after:rounded-full 
            after:bg-[#34343a]
            ${className}
          `}
        >
          {items.map((item) => (
            <li
              title={item.title}
              key={item.key}
              onClick={() => scrollToSection(item.key)}
              className={cls`
                 relative
                 cursor-pointer 
                 after:absolute
                 after:top-1 after:z-[2]
                 after:rounded-xl
                ${
                  isScroll
                    ? `${
                        active === item.key
                          ? `${activeStyle} after:-left-[12.9px] after:h-4 after:w-0.5`
                          : `text-f-text-secondary`
                      } `
                    : `text-f-text-secondary`
                }
              `}
            >
              <p className='two-line-ellipsis'>{item.title}</p>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}
export default ArticleAnchor
